/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
export class BarredLocationEntity extends Entity {
  addressCountry: string | null = null;
  addressState: string | null = null;
  createdAt: string | null = null;
  id: string = '';
  name: string | null = null;
  updatedAt: string | null = null;
  static override key = 'BarredLocation';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'BarredLocation' in input
    ) {
      const { BarredLocation: wrapped, ...rest } = input as {
        BarredLocation: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}